export default "__VITE_ASSET__sd$GvhK6__"